import { render, staticRenderFns } from "./tokitchen.vue?vue&type=template&id=2b3fb3ec&"
import script from "./tokitchen.vue?vue&type=script&lang=js&"
export * from "./tokitchen.vue?vue&type=script&lang=js&"
import style0 from "./tokitchen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports